module.exports = __webpack_public_path__ + "static/media/chart-area.7a566895.svg";